import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import _ from 'underscore';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  Skeletons,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table/config';
import Filter from './component/table/filter';
import Tutorial from './component/table/tutorial';

const initialState = {
  displayFilter: false,
  count: [],
  privilege: null,
};

const ContractScreen = () => {
  const Session = useSelector((state) => state.Auth?.session);
  const ContractTable = useTable('contract', tableConfig);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ displayFilter, count, privilege }, setState] =
    React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.contract',
    });
    setState((prevState) => ({
      ...prevState,
      privilege: x,
    }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle=""
        title={'Daftar Kontrak'}
        isLoading={StateLoading}
        action={
          privilege?.action === 'manage' || !Session?.privileges
            ? { url: '/order/contract/create', text: 'Buat Kontrak Baru' }
            : null
        }
      />

      <Page.Navigation>
        <Tutorial />
        <ContractTable.Tools downloadable isLoading={StateLoading}>
          {StateLoading ? (
            <div className="ms-2">
              <Skeletons height="35px" width="50px" />
            </div>
          ) : (
            <Button
              variant={displayFilter ? 'primary' : 'secondary'}
              className="ms-2 position-relative"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  displayFilter: !displayFilter,
                }))
              }
            >
              <Fi.FiFilter size={19} color="white" />
              {count?.length > 0 ? (
                <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger">
                  {count?.length}
                </span>
              ) : null}
            </Button>
          )}
        </ContractTable.Tools>
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            displayFilter ? 'col-md-9  m-0 p-0' : 'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <ContractTable.Render />
          )}
        </div>

        <Filter
          ContractTable={ContractTable}
          onClose={() =>
            setState((prevState) => ({
              ...prevState,
              displayFilter: false,
            }))
          }
          show={displayFilter}
          setCount={(x) =>
            setState((prevState) => ({
              ...prevState,
              count: x,
            }))
          }
        />
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <ContractTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default ContractScreen;
